import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaLocationArrow,
  FaClock,
  FaPaperPlane,
} from "react-icons/fa";
import { Formik } from "formik";
import * as Yup from "yup";
import Axios from "../Axios";
import { MyInput } from "../ui";
import Layout from "../utils/Layouts/Layout/Layout";
import Popup from "../utils/Popup/Popup";
import Header from "../utils/Header/Header";
import "./contact.scss";

const schema = Yup.object().shape({
  name: Yup.string().required("Хоосон байна!"),
  email: Yup.string()
    .email("Зөв форматаар бичнэ үү!")
    .matches(/[a-z0-9]+@[a-z]+\.[a-z]{2,3}/, "Зөв форматаар бичнэ үү!")
    .required("Хоосон байна!"),
  feedback: Yup.string().required("Хоосон байна!"),
});

const Contact = () => {
  const [popupType, setPopupType] = useState("");
  const [popupText, setPopupText] = useState("");
  const [visiblePopup, setVisiblePopup] = useState(false);

  const sendHandler = (values, { resetForm }) => {
    Axios.post("/feedbacks", values)
      .then((res) => {
        if (res.data.message === "success") {
          setPopupType("success");
          setPopupText("Таны хүсэлт амжилттай илгээгдлээ.");
          setVisiblePopup(true);
          resetForm();
        } else {
          setPopupType("sys_error");
          setPopupText("");
          setVisiblePopup(true);
        }
      })
      .catch(() => {
        setPopupType("sys_error");
        setPopupText("");
        setVisiblePopup(true);
      });
  };

  return (
    <Layout>
      <Header onHome={true} />

      <Popup
        messageType={popupType}
        messageText={popupText}
        visible={visiblePopup}
        onOk={() => setVisiblePopup(false)}
      />

      <section className="contactPage">
        <div className="contactPage__bgGlow contactPage__bgGlow--1" />
        <div className="contactPage__bgGlow contactPage__bgGlow--2" />
        <div className="contactPage__grid" />

        <div className="contactPage__hero mt-0">
          <span className="text-[70px]">Бидэнтэй холбогдоорой</span>
          <p>
            Санал хүсэлт, асуулт, хамтын ажиллагааны талаар бидэнтэй холбогдоно
            уу. Бид таны мессежийг хурдан хүлээн авч, эргэн хариу өгөх болно.
          </p>
        </div>

        <div className="contactPage__wrapper">
          <div className="contactPage__left">
            <div className="contactPage__miniStats">
              <div className="contactPage__miniStat">
                <strong>24/7</strong>
                <span>Онлайн хүлээн авалт</span>
              </div>
              <div className="contactPage__miniStat">
                <strong>1 өдөр</strong>
                <span>Дотор хариу өгөх</span>
              </div>
            </div>

            <div className="contactInfoCard">
              <div className="contactInfoCard__icon">
                <FaPhoneAlt />
              </div>
              <div className="contactInfoCard__content">
                <span className="contactInfoCard__label">Утасны дугаар</span>
                <h3>+976 8080-4949</h3>
                <p>Ажлын цагаар шууд холбогдох боломжтой</p>
              </div>
            </div>

            <div className="contactInfoCard">
              <div className="contactInfoCard__icon">
                <FaLocationArrow />
              </div>
              <div className="contactInfoCard__content">
                <span className="contactInfoCard__label">Имэйл хаяг</span>
                <h3>support@iotb.com</h3>
                <p>Санал хүсэлт болон албан хүсэлт хүлээн авна</p>
              </div>
            </div>

            <div className="contactInfoCard">
              <div className="contactInfoCard__icon">
                <FaClock />
              </div>
              <div className="contactInfoCard__content">
                <span className="contactInfoCard__label">Цагийн хуваарь</span>
                <h3>09:00 - 17:00</h3>
                <p>Ажлын өдрүүдэд тогтмол ажиллана</p>
              </div>
            </div>
          </div>

          <div className="contactFormCard">
            <div className="contactFormCard__top">
              <span className="contactFormCard__tag">Мэдээлэл</span>
              <h2>Санал хүсэлт илгээх</h2>
              <p>Доорх талбаруудыг бөглөөд бидэнд мессежээ үлдээнэ үү.</p>
            </div>

            <Formik
              initialValues={{
                name: "",
                email: "",
                feedback: "",
              }}
              validationSchema={schema}
              onSubmit={(values, { resetForm }) =>
                sendHandler(values, { resetForm })
              }
            >
              {({
                values,
                errors,
                touched,
                setFieldTouched,
                handleChange,
                handleSubmit,
              }) => (
                <form className="contactFormCard__form" onSubmit={handleSubmit}>
                  <div className="contactField">
                    <label>Нэр</label>
                    <MyInput
                      name="name"
                      placeholder="Нэрээ оруулна уу"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={setFieldTouched}
                      touched={touched.name}
                      errorText={errors.name}
                    />
                  </div>

                  <div className="contactField">
                    <label>Имэйл хаяг</label>
                    <MyInput
                      name="email"
                      placeholder="Имэйл хаягаа оруулна уу"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={setFieldTouched}
                      touched={touched.email}
                      errorText={errors.email}
                    />
                  </div>

                  <div className="contactField">
                    <label>Санал хүсэлт</label>
                    <div className="contactTextarea">
                      <textarea
                        name="feedback"
                        rows={5}
                        value={values.feedback}
                        placeholder="Энд санал хүсэлтээ бичнэ үү..."
                        onChange={handleChange}
                        onBlur={() => setFieldTouched("feedback", true)}
                      />
                    </div>

                    {touched.feedback && errors.feedback && (
                      <label className="contactField__error">
                        {errors.feedback}
                      </label>
                    )}
                  </div>

                  <button type="submit" className="contactSubmitBtn">
                    <FaPaperPlane />
                    <span>Илгээх</span>
                  </button>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
